var render = function render(_c,_vm){return _c('el-tag',_vm._b({staticClass:"app-label",class:{ variant_clickable: _vm.props.clickable },on:{"click":function($event){_vm.props.clickable ? _vm.listeners['click']() : null}}},'el-tag',_vm.props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }